import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, } from '@tribeplatform/react-ui-kit/FormControl';
import { MemberPicker } from './MemberPicker';
import { SpacePicker } from './SpacePicker';
export const PickerFormControl = ({ children }) => (_jsx("div", { className: "space-y-1", children: children }, void 0));
export const PickerFormControlSpace = props => {
    const { children, name, label, helperText, error, invalid, onChange, value, ...rest } = props;
    return (_jsxs("div", { children: [label ? (_jsx(FormControl.Label, { htmlFor: name, children: label }, void 0)) : null, _jsxs("div", { className: "mt-1", children: [_jsx(SpacePicker, { ...rest, value: value, onChange: onChange, children: children }, void 0), _jsx(FormControl.Meta, { ...{
                            helperText,
                            error,
                            invalid,
                        } }, void 0)] }, void 0)] }, void 0));
};
export const PickerFormControlMember = props => {
    const { children, name, label, helperText, error, invalid, onChange, value, ...rest } = props;
    return (_jsxs("div", { children: [label ? (_jsx(FormControl.Label, { htmlFor: name, children: label }, void 0)) : null, _jsxs("div", { className: "mt-1", children: [_jsx(MemberPicker, { ...rest, value: value, onChange: onChange, children: children }, void 0), _jsx(FormControl.Meta, { ...{
                            helperText,
                            error,
                            invalid,
                        } }, void 0)] }, void 0)] }, void 0));
};
PickerFormControl.SpacePicker = PickerFormControlSpace;
PickerFormControl.MemberPicker = PickerFormControlMember;
//# sourceMappingURL=PickerFormControl.js.map